import Joi from 'joi';

export default Joi.object({
	credit: Joi.number()
		.min(1)
		.error(() => ({
			message: 'Výše úvěru musí být celé kladné číslo.',
		})),
	payment: Joi.number()
		.min(1)
		.error(() => ({
			message: 'Měsíční splátka musí být celé kladné číslo.',
		})),
	number: Joi.number()
		.min(1)
		.max(999)
		.error(() => ({
			message: 'Počet měsíců musí být celé kladné číslo.',
		})),
	tax: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Poplatek za uzavření musí být celé kladné číslo.',
		})),
	monthlyFees: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Měsíční poplatky musí být celé kladné číslo.',
		})),
});
